import React from 'react'
import styled from 'styled-components'

import { useNavigate } from 'react-router'
import { ReactComponent as NavLogo } from '../../Assets/icons/landingPage/nav-logo-light.svg'
const Header = () => {
    const navigate = useNavigate()
    return (
        <HeaderContainer >
            <Content>
                <NavLogo onClick={() => {
                    navigate("/")
                }} />
            </Content>

        </HeaderContainer>
    )
}

export default Header

const HeaderContainer = styled.div`
display: flex;
width:100%;
justify-content: space-between;
align-items: center;
padding: 10px 120px;
min-height:40px;
margin-left: auto;
margin-right: auto;
background:${({ theme }) => theme.menu.background};
justify-content:center;
svg{
    cursor:pointer;
    width:80px;
}
@media (max-width: 768px) {
    padding: 40px 50px;
  }
  @media (max-width: 600px) {
    padding: 20px;
  }
`
const Content = styled.div`
max-width: 1440px;
display:flex;
width:100%;
`